import { render } from "./GamesIframe.vue?vue&type=template&id=51743226"
import script from "./GamesIframe.vue?vue&type=script&lang=js"
export * from "./GamesIframe.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__